import {
    faFolderOpen,
    faFolder,
    faClone,
    faMoneyCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IIndicadoresAtendimentoProps {
    NR_ATENDIMENTOS_ABERTOS: number | undefined;
    NR_ATENDIMENTOS_FECHADOS: number | undefined;
    NR_INTERACOES: number | undefined;
    NR_ATENDIMENTOS: number | undefined;
}

export default function IndicadoresAtendimento(
    props: IIndicadoresAtendimentoProps
) {
    return (
        <div className="card card-custom">
            <div className="card-body justify-content-center">
                <div className="d-flex align-items-center justify-content-between mr-2">
                    <div className="d-flex align-items-center w-50">
                        <div className="symbol symbol-45 symbol-light-success mr-4 flex-shrink-0">
                            <div className="symbol-label">
                                <span className="svg-icon svg-icon-lg svg-icon-danger">
                                    <FontAwesomeIcon icon={faFolderOpen} />
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className="font-size-h4 text-dark-75 font-weight-bolder">
                                {props.NR_ATENDIMENTOS_ABERTOS?.toLocaleString()}
                            </div>
                            <div className="font-size-sm text-muted font-weight-bold mt-1">
                                Atendimentos em Aberto
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center w-50">
                        <div className="symbol symbol-45 symbol-light-danger mr-4 flex-shrink-0">
                            <div className="symbol-label">
                                <span className="svg-icon svg-icon-lg svg-icon-danger">
                                    <FontAwesomeIcon icon={faFolder} />
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className="font-size-h4 text-dark-75 font-weight-bolder">
                                {props.NR_ATENDIMENTOS_FECHADOS?.toLocaleString()}
                            </div>
                            <div className="font-size-sm text-muted font-weight-bold mt-1">
                                Atendimentos Fechados
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mr-2 mt-3">
                    <div className="d-flex align-items-center w-50">
                        <div className="symbol symbol-45 symbol-light-primary mr-4 flex-shrink-0">
                            <div className="symbol-label">
                                <span className="svg-icon svg-icon-lg svg-icon-danger">
                                    <FontAwesomeIcon icon={faClone} />
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className="font-size-h4 text-dark-75 font-weight-bolder">
                                {props.NR_ATENDIMENTOS?.toLocaleString()}
                            </div>
                            <div className="font-size-sm text-muted font-weight-bold mt-1">
                                Total de Atendimentos
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center w-50">
                        <div className="symbol symbol-45 symbol-light-warning mr-4 flex-shrink-0">
                            <div className="symbol-label">
                                <span className="svg-icon svg-icon-lg svg-icon-danger">
                                    <FontAwesomeIcon icon={faMoneyCheck} />
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className="font-size-h4 text-dark-75 font-weight-bolder">
                                {props.NR_INTERACOES?.toLocaleString()}
                            </div>
                            <div className="font-size-sm text-muted font-weight-bold mt-1">
                                Total de Interações
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
